module.exports = __webpack_public_path__ + "static/img/5.9a9350b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/5.png
// module id = hjnM
// module chunks = 0